import { Identifiable, Project } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function updateProjectAllocatedExpensesBudget(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Project>, allocatedExpensesBudget: number) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/projects/${uuid}`,
      method: HttpMethods.PATCH,
      data: { allocatedExpensesBudget },
    });
}

export { updateProjectAllocatedExpensesBudget };
